class CarouselBanners extends HTMLElement {
  constructor() {
    super();

    this.randomNum = Math.round(Math.random() * 10000);

    this.swiperEl = this.querySelector(".carousel-banners-swiper");
    this._initSwiper = this._initSwiper.bind(this);
    this._sectionrenderLogic();
  }

  _sectionrenderLogic() {
    if (!this.swiperEl) return;

    const initSwiper = () => {
      const isAboveFold = this.getBoundingClientRect().top < window.innerHeight;

      if (isAboveFold) {
        window.swiperLoader.initImmediately(this._initSwiper);
      } else {
        const viewportHeight = window.innerHeight;
        window.swiperLoader.initWhenVisible(this, this._initSwiper, {
          rootMargin: `${viewportHeight}px`,
          threshold: 0.1,
        });
      }
    };

    if (window.swiperLoader) {
      initSwiper();
    } else {
      window.addEventListener("swiperloader:ready", initSwiper, { once: true });
    }

    window.addEventListener("resize", () => {
      this.style.removeProperty("--slides-height");
      setTimeout(() => {
        if (this.swiper && window.Swiper) {
          this._initSwiper(window.Swiper);
        }
      }, 80);
    });
  }

  _initSwiper(Swiper) {
    if (!Swiper) return;

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    const swiperId = "carousel-banners-swiper-" + this.randomNum;
    const arrowLeft = this.querySelector(".swiper-button-prev");
    const arrowRight = this.querySelector(".swiper-button-next");
    if (arrowLeft && arrowRight) {
      arrowLeft.classList.add(`${swiperId}-arrow-left`);
      arrowRight.classList.add(`${swiperId}-arrow-right`);
    }
    this.swiperEl.classList.add(swiperId);
    const config = {
      slidesPerView: 1,
      centeredSlides: true,
      loop: false,
      // autoHeight: true,
      spaceBetween: 0,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        prevEl: `.${swiperId}-arrow-left`,
        nextEl: `.${swiperId}-arrow-right`,
      },
    };

    this.swiper = new Swiper(`.${swiperId}`, config);

    const slides = this.querySelectorAll(".swiper-slide");
    const biggestHeight = Math.max(
      ...Array.from(slides).map((s) => s.offsetHeight),
    );

    //create a css variable for the height
    this.style.setProperty("--slides-height", `${biggestHeight}px`);
  }
}

customElements.define("carousel-banners", CarouselBanners);
